// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs import
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { plainToClass } from 'class-transformer';

// Constant imports
import { URLConstants } from '../../../../_constants/url-constants';

// model Imports
import { BaseCiraBooksParameterDto } from '../../_models/common/base-cirabooks-parameter-dto';
import { EntityClosedBookPeriodResultDto } from '../../_models/common/entity-closed-book-period-result-dto';
import { EntityFisicalYearResultDto } from '../../_models/common/entity-fisical-year-result-dto';
import { EntityFisicalYearParametersDto } from '../../_models/common/entity-fisical-year-parameters-dto';
import { ARInvoiceDetailParameterDto } from '../../_models/account-receivable/ar-invoice/ar-invoice-detail-parameter-dto';
import { ReverseEditorResultDto } from '../../../../shared-module/_models/reverse-editor-result-dto';

@Injectable({
    providedIn: 'root'
})
export class CBSharedService {
    constructor(private readonly httpClient: HttpClient) {}

    getEntityClosedBookPeriod(params: BaseCiraBooksParameterDto): Observable<EntityClosedBookPeriodResultDto> {
        const url = URLConstants.ccCBGLOpenCloseBooksApiUrl + `/closedperiod${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((plain: any) => plainToClass(EntityClosedBookPeriodResultDto, plain)));
    }

    getEntityFiscalYear(params: EntityFisicalYearParametersDto): Observable<EntityFisicalYearResultDto> {
        const url = URLConstants.ccCBGLOpenCloseBooksApiUrl + `/fiscalyear${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((plain: any) => plainToClass(EntityFisicalYearResultDto, plain)));
    }

    getEntityReverseEditor(params: ARInvoiceDetailParameterDto): Observable<ReverseEditorResultDto> {
        const url = URLConstants.ccInvoiceApiUrl + `/reverse/editor${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((plain: any) => plainToClass(ReverseEditorResultDto, plain)));
    }
}
